import { z } from "zod";
import { songSchema } from "./song";

export const albumSchema = z.object({
  id: z.string(),
  title: z.string(),
  artistDisplayText: z.string().trim(),
  image: z.string().nullable(),
  artistIds: z.array(z.string()),
  releaseDate: z.string().nullable(),
  hasPrivateSong: z.boolean(),
  privateSongIds: z.array(z.string()),
});

export type Album = z.infer<typeof albumSchema>;

export const albumWithSongsSchema = albumSchema.extend({
  songs: z.array(
    songSchema.pick({
      artists: true,
      duration: true,
      id: true,
      title: true,
      urlOnline: true,
    }),
  ),
});

export type AlbumWithSongs = z.infer<typeof albumWithSongsSchema>;

export const searchAlbumSchema = albumSchema.extend({
  type: z.literal("album"),
});

export type SearchAlbum = z.infer<typeof searchAlbumSchema>;

export const albumLibrarySchema = albumWithSongsSchema.extend({
  type: z.literal("album"),
});

export type AlbumLibrary = z.infer<typeof albumLibrarySchema>;
